import { View } from '../../primitives/View';
import { bottomSheetContentFadeVariants } from './BottomSheet.variants';

/**
 * Scroll-affordance fade for the content surface — web.
 *
 * Same job as the `.native` sibling (see it for the why), but web Tailwind has
 * real gradient utilities, so this is a class rather than a gradient element.
 */
export function BottomSheetContentFade({
  edge,
  dotted = false,
}: {
  edge: 'top' | 'bottom';
  /** A dotted slot — its fill is the page colour in dark. */
  dotted?: boolean;
}) {
  return <View className={bottomSheetContentFadeVariants({ edge, dotted })} />;
}
BottomSheetContentFade.displayName = 'BottomSheetContentFade';
